import { render } from "./MainSurveysInfo.vue?vue&type=template&id=1ec67125"
import script from "./MainSurveysInfo.vue?vue&type=script&lang=js"
export * from "./MainSurveysInfo.vue?vue&type=script&lang=js"

import "./MainSurveysInfo.vue?vue&type=style&index=0&id=1ec67125&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__